import React from "react";

export default function JobSwmsFormV3DropIndicator({ draggingSectionKey, dropLineY }) {
  if (!draggingSectionKey || dropLineY === null) {
    return null;
  }

  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "10px",
        right: "10px",
        top: `${dropLineY}px`,
        height: "2px",
        backgroundColor: "#7C3AED",
        transform: "translateY(-1px)",
        pointerEvents: "none",
        zIndex: 12
      }}
    />
  );
}